export function bearingDeg(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const toRad = (v: number) => (v * Math.PI) / 180;

  const dLon = toRad(lon2 - lon1);
  const y = Math.sin(dLon) * Math.cos(toRad(lat2));
  const x =
    Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
    Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLon);

  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
}

/**
 * Converts the stored Umbra ScanSAR LineString target into the frontend's
 * existing 2-Point array format. All other shapes are returned unchanged.
 */
export function normalizeTaskTarget(rawTarget: string): string {
  if (!rawTarget) return rawTarget;

  try {
    const parsed = JSON.parse(rawTarget);
    if (
      parsed &&
      typeof parsed === 'object' &&
      !Array.isArray(parsed) &&
      parsed.type === 'LineString' &&
      Array.isArray(parsed.coordinates) &&
      parsed.coordinates.length === 2
    ) {
      const [firstPoint, secondPoint] = parsed.coordinates;
      return JSON.stringify([
        { type: 'Point', coordinates: firstPoint },
        { type: 'Point', coordinates: secondPoint },
      ]);
    }
  } catch {
    // Return the original payload when it is not valid JSON.
  }

  return rawTarget;
}
